import { useState } from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import userApi from "../../api/user/user.api";
import { setAuthModalOpen } from "../../redux/features/authModalSlice";
import { setUser } from "../../redux/features/userSlice";

import { login } from "../../redux/features/authSlice";
import ProcessingBar from "../../Util/Processingbar";

const SigninForm = ({ switchAuthState, actionState }) => {
  const dispatch = useDispatch();
  const [isLoginRequest, setIsLoginRequest] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const signinForm = useFormik({
    initialValues: {
      password: "",
      username: "",
    },
    validationSchema: Yup.object({
      username: Yup.string()
        .min(3, "Username must be at least 3 characters")
        .required("Username is required"),
      password: Yup.string()
        .min(3, "Password must be at least 3 characters")
        .required("Password is required"),
    }),
    onSubmit: async (values) => {
      setErrorMessage("");
      setIsLoginRequest(true);
      // let responseLogin = dispatch(login(values));
      const { response, err } = await userApi.signin(values);

      // console.log({ response });

      if (response) {
        signinForm.resetForm();
        setIsLoginRequest(false);
        dispatch(setUser(response.data));
        dispatch(setAuthModalOpen(false));
        toast.success("Sign in successful");
      }

      if (err) {
        setErrorMessage(err.message);
        setIsLoginRequest(false);
      }
    },
  });

  return (
    <form onSubmit={signinForm.handleSubmit} className="space-y-4">
      {/* Username Input */}
      <input
        type="text"
        name="username"
        placeholder="Email"
        className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
        value={signinForm.values.username}
        onChange={signinForm.handleChange}
      />
      {signinForm.touched.username && signinForm.errors.username && (
        <p className="text-red-500 text-sm">{signinForm.errors.username}</p>
      )}

      {/* Password Input */}
      <input
        type="password"
        name="password"
        placeholder="Password"
        className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
        value={signinForm.values.password}
        onChange={signinForm.handleChange}
      />
      {signinForm.touched.password && signinForm.errors.password && (
        <p className="text-red-500 text-sm">{signinForm.errors.password}</p>
      )}

      {/* Sign In Button */}
      <button
        type="submit"
        className="w-full text-black hover:text-white py-2 rounded-md transition duration-300"
        disabled={isLoginRequest}
        style={{
          background: "linear-gradient(-45deg, #fed693, #ca7100)",
        }}
      >
        {isLoginRequest ? <ProcessingBar /> : "Sign In"}
      </button>
      <button
        type="button"
        onClick={() => switchAuthState(actionState.forgot)}
        className="text-yellow-500 text-sm hover:underline block text-center"
      >
        Forgot your password?
      </button>

      {/* Divider */}
      <div className="flex items-center my-8">
        <div className="flex-grow h-px bg-gray-500"></div>
        <span className="px-4 text-sm text-neutral-300">OR</span>
        <div className="flex-grow h-px bg-gray-500"></div>
      </div>

      {/* Sign Up Link */}
      <button
        type="button"
        onClick={() => switchAuthState("signup")}
        className="w-full text-center text-yellow-500 hover:text-white mt-4 py-2 rounded-md border border-yellow-700"
      >
        Sign Up
      </button>

      {/* Error Message */}
      {errorMessage && (
        <p className="text-red-500 text-sm text-center">{errorMessage}</p>
      )}
    </form>
  );
};

export default SigninForm;
